import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { AppUpdateService } from './core/services/app-update.service';
import { environment } from 'environments/environment';


@Component({
    standalone: false,
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent
{
    /**
     * Constructor
     */
    constructor(private titleService: Title,
                private appUpdateService: AppUpdateService,
                @Inject(DOCUMENT) private document: Document)
    {
        // Set title with [PRE] prefix for non-production environments
        const baseTitle = 'RETMI - Apps';
        const title = environment.production ? baseTitle : `[PRE] ${baseTitle}`;
        this.titleService.setTitle(title);
        // Set favicon from environment configuration
        this._setFavicon(environment.faviconUrl);
        // Initialize the app update service
        this.appUpdateService.init();
    }

    private _setFavicon(url: string): void
    {
        const link: HTMLLinkElement =
            this.document.querySelector('#app-favicon') ||
            this.document.createElement('link');
        link.id   = 'app-favicon';
        link.rel  = 'icon';
        link.type = url.endsWith('.ico') ? 'image/x-icon' : 'image/png';
        link.href = url;
        if (!link.parentNode)
        {
            this.document.head.appendChild(link);
        }
    }
}
